import React, { Fragment } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { getOptionsForHardcodedState } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { omit } from '@utils/miscellaneous/objectHelpers';

const MailingAddressInputs = props => {

    const {
        _postalCode,
        _countyCode,
        _streetAddress1,
        _streetAddress2,
        _state,
        _city,
        currentData,
        counties,
        fields,
        stateCode = undefined,
        isInputStandalone = false,
        disabled,
        isState = {},
        addressConfidentialityParticipant = false,
        ...restProps
    } = props;

    const cleanedRestProps = omit(restProps, 'children');

    // Safe At Home participants provide a lot number in place of a street address,
    // so the streetAddress1 field's copy switches over accordingly

    const streetAddress1Copy = addressConfidentialityParticipant
        ? {
            label: 'ssap.input.label.lot_number',
            placeholder: 'ssap.input.placeholder.lot_number',
            validationErrorMessage: VALIDATION_ERROR_MESSAGES.LOT_NUMBER
        }
        : {
            label: 'ssap.input.label.address_line_one',
            placeholder: 'ssap.input.placeholder.address_line_one',
            validationErrorMessage: undefined
        };

    return (
        <Fragment>
            <UniversalInput
                label = { {
                    text: streetAddress1Copy.label,
                    labelClasses: []
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress1',
                    helperClasses: [],
                    value: _streetAddress1,
                    placeholder: streetAddress1Copy.placeholder,
                    validationType: VALIDATION_TYPES.ADDRESS_LINE1,
                    validationErrorMessage: streetAddress1Copy.validationErrorMessage,
                    valuesToMatch: isState,
                    currentData: currentData,
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.address_line_two',
                    labelClasses: []
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress2',
                    helperClasses: [],
                    value: _streetAddress2,
                    placeholder: 'ssap.input.placeholder.address_line_two',
                    validationType: VALIDATION_TYPES.ADDRESS_LINE2,
                    valuesToMatch: isState,
                    currentData: currentData,
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    disabled,
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.city',
                    labelClasses: []
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'city',
                    helperClasses: [],
                    value: _city,
                    placeholder: 'ssap.input.placeholder.city',
                    validationType: VALIDATION_TYPES.CITY,
                    currentData: currentData,
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    disabled,
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.zip',
                    labelClasses: []
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'postalCode',
                    helperClasses: [],
                    value: _postalCode,
                    placeholder: 'ssap.input.placeholder.zip',
                    validationType: VALIDATION_TYPES.ZIP_CODE_5_DIGITS,
                    currentData: currentData,
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    disabled,
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.state',
                    isLabelRequired: true
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'state',
                    value: stateCode ? stateCode : _state,
                    options: stateCode ? getOptionsForHardcodedState(stateCode) : DROPDOWN_OPTIONS.STATE,
                    validationType: VALIDATION_TYPES.CHOSEN,
                    currentData: JSON.parse(JSON.stringify(currentData)),
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    disabled,
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
            <UniversalInput
                label = { {
                    text: 'ssap.input.label.county',
                    isLabelRequired: true
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'countyCode',
                    value: _countyCode,
                    options: DROPDOWN_OPTIONS.COUNTIES_FOR_EXACT_ZIPCODE(counties),
                    valuesToMatch: counties.map(county => Object.keys(county)[0]),
                    validationType: VALIDATION_TYPES.CHOSEN_FROM_LIST,
                    currentData: currentData,
                    fields: fields ? fields : [ 'householdContact', 'mailingAddress' ],
                    disabled,
                    isInputStandalone
                } }
                { ...cleanedRestProps }
            />
        </Fragment>
    );
};

export default MailingAddressInputs;